var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page",attrs:{"fluid":""}},[_c('c-nav-bar',{staticClass:"header",attrs:{"page":this.$route.meta.title}}),_c('router-view',{staticClass:"content"}),_c('c-footer',{staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }